.textField {
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  min-width: 0;
  flex: 1 1 auto;
}

.inputLabel {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
  transform-origin: top left;
  pointer-events: none;
}

.input {
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body1-fontSize);
  line-height: var(--tuna-typography-body1-lineHeight);
  color: var(--tuna-content-primary);
  padding: 8.5px 14px;
  /* Light rest sides; the bottom edge is the 3:1 identifying boundary (WCAG 1.4.11) */
  border: 1px solid var(--tuna-border-field);
  border-bottom-color: var(--tuna-content-secondary);
  border-radius: var(--tuna-shape-borderRadius);
  background: none;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color var(--tuna-transitions-duration-shorter) var(--tuna-transitions-easing-easeInOut);
}

.input:hover {
  border-color: var(--tuna-content-primary);
}

.input:focus {
  border-color: var(--tuna-palette-primary-main);
  border-width: 2px;
  padding: 7.5px 13px;
}

.error {
  border-color: var(--tuna-feedback-error);
}

.standard {
  border: none;
  border-radius: 0;
  padding: 4px 0;
  background: transparent;
  font-size: inherit;
}

.standard:hover {
  border: none;
}

.standard:focus {
  border: none;
  padding: 4px 0;
}

.filled {
  border: none;
  border-bottom: 1px solid var(--tuna-content-secondary);
  border-radius: var(--tuna-shape-borderRadius) var(--tuna-shape-borderRadius) 0 0;
  background-color: var(--tuna-palette-action-hover);
  padding: 8.5px 12px;
}

.filled:hover {
  border-bottom-color: var(--tuna-palette-text-primary);
  background-color: var(--tuna-palette-action-selected);
}

.filled:focus {
  border-bottom: 2px solid var(--tuna-palette-primary-main);
  padding-bottom: 7.5px;
}

.sizeSmall {
  padding: 4px 10px;
  font-size: var(--tuna-typography-body2-fontSize);
}

.input:disabled {
  color: var(--tuna-palette-text-disabled);
  border-color: var(--tuna-palette-action-disabledBackground);
  cursor: default;
}

.input:has(.adornmentInner:focus) {
  border-color: var(--tuna-palette-primary-main);
  border-width: 2px;
  padding: 7.5px 13px;
}

.adornmentInner {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  border: none;
  background: none;
  outline: none;
  padding: 0;
  flex: 1;
  min-width: 0;
}

.multiline {
  resize: vertical;
  min-height: 56px;
}

.helperText {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
  font-family: var(--tuna-typography-fontFamily);
  margin: 3px 14px 0;
}

.helperTextError {
  color: var(--tuna-palette-error-main);
}
